import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Priya Sharma',
      role: 'Marketing Manager, Mumbai',
      avatar: 'PS',
      content: 'AssistlyAI has transformed how I manage my day. Setting reminders through WhatsApp feels so natural. I never miss a meeting now!',
      rating: 5,
    },
    {
      name: 'Rajesh Kumar',
      role: 'Startup Founder, Bangalore',
      avatar: 'RK',
      content: 'As a founder juggling multiple things, AssistlyAI is like having a PA I can actually afford. The Hindi support is amazing!',
      rating: 5,
    },
    {
      name: 'Ananya Gupta',
      role: 'CA, Delhi',
      avatar: 'AG',
      content: 'During tax season, I need to track 100 client deadlines. AssistlyAI keeps me on top of everything. Best ₹149 I spend every month.',
      rating: 5,
    },
    {
      name: 'Vikram Malhotra',
      role: 'Sales Director, Pune',
      avatar: 'VM',
      content: 'I was skeptical at first, but AssistlyAI genuinely saves me 2 hours every day. My team thinks I have superpowers now!',
      rating: 5,
    },
    {
      name: 'Sneha Patel',
      role: 'Doctor, Ahmedabad',
      avatar: 'SP',
      content: 'Between patients and hospital rounds, AssistlyAI helps me remember everything. The quick summaries of my notes are lifesavers.',
      rating: 5,
    },
    {
      name: 'Arjun Reddy',
      role: 'Tech Lead, Hyderabad',
      avatar: 'AR',
      content: 'Finally, an AI assistant that understands Hinglish! I can type "kal 3 baje meeting fix karo" and it just works.',
      rating: 5,
    },
  ];

  // Double the testimonials for infinite scroll effect
  const doubledTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="py-24 lg:py-32 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <span className="text-[#25D366] font-semibold text-sm uppercase tracking-wider">Testimonials</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
            Real professionals.
            <br />
            <span className="text-slate-500 dark:text-slate-400">Real results. Real WhatsApp chats.</span>
          </h2>
        </motion.div>
      </div>

      {/* Marquee */}
      <div className="relative">
        {/* Gradient Fade Left */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white dark:from-slate-950 to-transparent z-10" />
        {/* Gradient Fade Right */}
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white dark:from-slate-950 to-transparent z-10" />

        <div className="flex animate-marquee">
          {doubledTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[350px] mx-3"
            >
              <div className="bg-white dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700/50 rounded-2xl p-6 h-full">
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-slate-700 dark:text-slate-300 mb-6 leading-relaxed">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#25D366] to-emerald-500 flex items-center justify-center text-white font-semibold text-sm">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900 dark:text-white">{testimonial.name}</p>
                    <p className="text-sm text-slate-500 dark:text-slate-400">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Stats */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-16"
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '2,000+', label: 'Active Users' },
            { value: '50K+', label: 'Tasks Completed' },
            { value: '4.9/5', label: 'User Rating' },
            { value: '2hrs', label: 'Saved Daily' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-3xl lg:text-4xl font-extrabold text-slate-900 dark:text-white">{stat.value}</p>
              <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
